import { Breadcrumbs } from "../../AbstractElements";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { CKEditorExample } from "../../Constant";
import HeaderCard from "../Common/HeaderCard";

const CkEditorContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs title="Ck Editor" parent="Editors" pageTitle="Ck Editor" />
      <Row>
        <Col sm="12">
          <Card>
            <HeaderCard title={CKEditorExample} />
            <CardBody>
              <CKEditor editor={ClassicEditor} data={"Hello!, This is content."} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default CkEditorContain;
